export default __webpack_public_path__ + "static/media/loading.468e9e96.svg";